import "../scss/style.scss";
import "@css/promoarh.pcss";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';


import '@js/parts/timer';
import '@js/parts/counter';

var customModal = document.querySelector("#dialog-content");

if (customModal) {
    var dataAllowClosing = customModal.getAttribute("data-allow-closing");
    var popupId = customModal.getAttribute("data-id");
    var hasPopupBeenClosed = localStorage.getItem(popupId + "-closed");
    if (!hasPopupBeenClosed) {
        Fancybox.show([{
            src: "#dialog-content", type: "inline"
        }], {
            mainClass: "custom-modal",
            on: {
                close: function () {
                    if (dataAllowClosing !== null) {
                        localStorage.setItem(popupId + "-closed", true);
                    }
                }
            }
        });
    }

}

Fancybox.bind('[data-fancybox]', {
    // Your custom options for a specific gallery
});

document.addEventListener('alpine:init', () => {
    Alpine.data('youtubeEmbed', () => ({
      init() {
          // Find all oembed elements
          const oembedElements = document.querySelectorAll('oembed[url]');
  
          oembedElements.forEach(element => {
              const url = element.getAttribute('url');
              const videoId = this.extractYouTubeId(url);
  
              if (videoId) {
                  const iframe = document.createElement('iframe');
                  iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
                  iframe.setAttribute('width', '560');
                  iframe.setAttribute('height', '315');
                  iframe.setAttribute('frameborder', '0');
                  iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                  iframe.setAttribute('allowfullscreen', 'true');
                  iframe.title = "YouTube video player";
                  iframe.loading = "lazy";
                  iframe.style.aspectRatio = "16/9";
                  iframe.style.width = "100%";
                  iframe.style.display = "block";
                  iframe.style.height = "auto";
                  iframe.style.margin = "1.5rem auto";
  
                  if (element.parentNode) {
                      element.parentNode.replaceChild(iframe, element);
                  }
              }
          });
      },
  
      extractYouTubeId(url) {
          if (!url) return null;
          const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
          const matches = url.match(regex);
          return matches ? matches[1] : null;
      }
  }));
  });


  window.Alpine = Alpine;
Alpine.start();


// Initialize the map when the page is loaded
// window.addEventListener("load", () => {
//     initMap();
// });

window.scrollToElement = function (target) {
    const element = document.getElementById(target);
    if (!element) return;

    const offset = 150;
    const offsetPosition = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}